import React, { Fragment, useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../toast/SetToast";
import { useHistory } from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import { db } from "../../../../firebase";
import {
  collection,
  updateDoc,
  doc,
  query,
  limit,
  deleteDoc,
  orderBy,
  where,
  Query,
  or,
  getDocs,
  getDoc,
  and,
} from "firebase/firestore";
import MaskItem from "./MaskItem";
import MaskRegister from "./MaskRegister";
import MaskEdit from "./MaskEdit";
import { useFirestore } from "../../../../hook/useFirestore";
import { usePagination } from "../../../../hook/usePagination";
import PageTitle from "../../../layouts/PageTitle";
import useQueryParams from "../../../../hook/useQueryParam";

const MaskItemList = () => {
  const [maskList, setMaskList] = useState([]);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [maskEdit, setMaskEdit] = useState({});
  const [copyMask, setCopyMask] = useState({});
  const [sortBy, setSortBy] = useState("maskName");
  const [sortDrirection, setSortDrirection] = useState("asc");
  const [node, setNode] = useState("ALL");
  const [statusFilter, setStatusFilter] = useState("ทั้งหมด");
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchMask, setSearchMask] = useState(null);

  const searchRef = useRef("");

  const sortByList = ["asc", "desc"];
  const sortDrirectionList = ["asc", "desc"];
  const statusList = ["ทั้งหมด", "Active", "Inactive"];

  let QueryFilterConstraint = [];
  let queryRef = query(
    collection(db, "masks"),
    orderBy(sortBy, sortDrirection)
  );

  if (searchMask !== null) {
    QueryFilterConstraint.push(
      where("maskName", ">=", searchMask),
      where("maskName", "<=", searchMask + "\uf8ff")
    );

    queryRef = query(
      collection(db, "masks"),
      and(...QueryFilterConstraint),
      orderBy(sortBy, sortDrirection)
    );
  }

  if (statusFilter !== null) {
    if (statusFilter !== "ทั้งหมด") {
      QueryFilterConstraint.push(where("IsActive", "==", statusFilter));

      queryRef = query(
        collection(db, "masks"),
        and(...QueryFilterConstraint),
        orderBy(sortBy, sortDrirection)
      );
    }
  }

  if (node !== "ALL") {
    QueryFilterConstraint.push(where("node", "==", node));

    queryRef = query(
      collection(db, "masks"),
      and(...QueryFilterConstraint),
      orderBy(sortBy, sortDrirection)
    );
  }

  const {
    items: maskInfo,
    isLoading,
    isStart,
    isEnd,
    getPrev,
    getNext,
    totalItems,
    totalPages,
    currentPage,
    goToPage,
  } = usePagination(queryRef, { limit: itemsPerPage });

  const { addDocument, deleteDocument } = useFirestore("masks");

  const handleOnNewMask = () => {
    setShowRegisterModal(true);
  };

  const handleOnEdit = async (id) => {
    const ref = doc(db, "masks", id);
    setMaskEdit(maskInfo.find((c) => c.id === id));
    // setMaskEdit({ id });
    setShowEditModal(true);
  };

  const handleOnCopy = async (id) => {
    try {
      const maskRef = doc(db, "masks", id);
      const maskData = await getDoc(maskRef);
      if (maskData.exists()) {
        const copyData = {
          ...maskData.data(),
          maskName: `${maskData.data().maskName} (Copy)`,
        };
        delete copyData.id;
        await addDocument(copyData);
        notifyTopRight("Mask copied successfully", 3000);
      }
    } catch (error) {
      console.error("Error copying mask:", error);
      notifyError("Failed to copy mask");
    }
  };

  const handleOnRegisterHide = () => {
    setShowRegisterModal(false);
  };

  const handleOnEditHide = () => {
    setShowEditModal(false);
  };

  const handleOnDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this mask!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteDocument(id);
        notifyTopRight("Mask deleted successfully", 3000);
      }
    });
  };

  const editUpdateMask = (id, update) => {
    const updatedMasks = maskInfo.map((mask) => {
      if (mask.id === id) {
        return {
          ...mask,
          ...update,
        };
      }
      return mask;
    });
    setMaskList(updatedMasks);
  };

  const handleSearchChange = () => {
    setSearchMask(searchRef.current.value);
  };

  const handleStatusChange = (status) => {
    setStatusFilter(status);
  };

  const handleSortDrirectionChange = (drirection) => {
    setSortDrirection(drirection);
  };

  const handleNodeChange = (selectedNode) => {
    setNode(selectedNode);
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Mask Items" motherMenu="Items" />
      <div className="form-head d-flex mb-3 mb-lg-5 align-items-center">
        <Button
          className="btn btn-danger"
          onClick={handleOnNewMask}
          data-toggle="tooltip"
          data-placement="top"
          title="Mask Registration"
        >
          + New Mask
        </Button>
        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search Item"
            ref={searchRef}
            onChange={handleSearchChange}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
        <Dropdown
          className="align-items-end d-inline-flex ml-2"
          onSelect={(option) => handleSortDrirectionChange(option)}
        >
          <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
            <i className="flaticon-381-controls-3 "></i> by{" "}
            {sortDrirection === "asc" ? "A-Z" : "Z-A"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-right">
            {sortDrirectionList.map((element, index) => {
              return (
                <Dropdown.Item href="#" eventKey={element}>
                  {element === "asc" ? "A-Z" : "Z-A"}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown
          className="align-items-end d-inline-flex ml-2"
          onSelect={(option) => handleStatusChange(option)}
        >
          <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
            <i className="flaticon-381-menu-1"></i>
            {statusFilter === "ทั้งหมด" && "Status"} {statusFilter}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-right">
            {statusList.map((element, index) => {
              return (
                <Dropdown.Item href="#" eventKey={element}>
                  {element}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <MaskItem
        items={maskInfo}
        onEdit={handleOnEdit}
        onDelete={handleOnDelete}
        onCopy={handleOnCopy}
        totalItems={totalItems}
        totalPages={totalPages}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        goToPage={goToPage}
        isStart={isStart}
        isEnd={isEnd}
        getNext={getNext}
        getPrev={getPrev}
      />

      <MaskRegister
        show={showRegisterModal}
        onHide={handleOnRegisterHide}
        onAdded={addDocument}
      />

      <MaskEdit
        mask={maskEdit}
        show={showEditModal}
        onHide={handleOnEditHide}
        onUpdate={editUpdateMask}
      />
    </Fragment>
  );
};

export default MaskItemList;
